const SETTINGS_LS_KEY = 'sub_settings_key';


const selected_services = localStorage.getItem('sub_services')
const service_params = localStorage.getItem('sub_params')
const discounts_service = localStorage.getItem('discounts')
const settings = localStorage.getItem(SETTINGS_LS_KEY)

let services = []
let params = []
let user_services = []
let service_settings = {
    plus_period: 0,
    plus_slots: 0,
    discount: 0,
    slot_items: []
}

let current_discounts = []
if (selected_services) {
    services = JSON.parse(selected_services)
}
if (service_params) {
    params = JSON.parse(service_params)
}
if (discounts_service) {
    current_discounts = JSON.parse(discounts_service)
}
if (settings) {
    service_settings = JSON.parse(settings)
}


export default {
    namespaced: true,
    state: {
        id: 0,
        step: 0,
        services: services,
        params: params,
        discounts: [],
        discount: current_discounts,
        slotsModal: {
            id: 0,
            show: false,
            items: [],
            max: 1
        },
        current_user_services: user_services,

        settings: service_settings,

        current: {
            unit_count: 0,
            slots: []
        }
    },
    mutations: {

        SETTINGS_SET_PERIOD(state, period) {
            state.settings.plus_period = period

            let discount = state.discounts.filter((item) => {
                return item.duration <= period
            }).map((item) => {
                return item.discount
            })

            discount.push(0)
            state.settings.discount = Math.max(...discount)

            localStorage.setItem(SETTINGS_LS_KEY, JSON.stringify(state.settings))
        },
        SETTINGS_SET_SLOTS(state, slots) {
            state.settings.plus_slots = slots
            localStorage.setItem(SETTINGS_LS_KEY, JSON.stringify(state.settings))
        },
        SETTINGS_SET_ITEMS(state, items) {
            state.settings.slot_items = items
            localStorage.setItem(SETTINGS_LS_KEY, JSON.stringify(state.settings))
        },
        ADD_TO_SETTINGS(state, items) {
            let item_list = state.settings.slot_items
            if (items) {
                items.forEach((item) => {
                        {
                            if (!state.settings.slot_items.some(c => c.entity_id === item.entity_id)) {
                                item_list.push(item)
                            }
                        }
                    }
                )
                state.settings.slot_items = [...new Map(item_list.map(item => [item['entity_id'], item])).values()]
                console.log(state.settings.slot_items)
            }
        },
        SETTINGS_TOGGLE_SLOT(state, slot) {
            const index = state.settings.slot_items.map(item => item.id).indexOf(slot.id)
            if (index < 0) {
                state.settings.slot_items.push(slot)
            } else {
                state.settings.slot_items.splice(index, 1)
            }
            localStorage.setItem(SETTINGS_LS_KEY, JSON.stringify(state.settings))
        },


        SET_STEP(state, step) {
            state.step = step
        },
        SET_DISCOUNTS(state, discounts) {
            state.discounts = discounts
        },
        ADD_SERVICE(state, service) {
            state.services.push(service)
            state.params.push({service_id: service.id, duration: 1, slots: 1, items: []})
            state.discount[service.id] = 0
            localStorage.setItem('sub_services', JSON.stringify(state.services))
            localStorage.setItem('sub_params', JSON.stringify(state.params))
        },
        REMOVE_SERVICE(state, index) {
            state.services.splice(index, 1)
            localStorage.setItem('sub_services', JSON.stringify(state.services))
        },
        CLEAR_PARAMS(state, index) {
            state.params.splice(index, 1)
            localStorage.setItem('sub_params', JSON.stringify(state.params))
        },
        SET_DURATION(state, {index, service_id, duration}) {
            state.id = service_id
            let params = state.params.filter((param) => {
                return param.service_id === service_id
            })[0]

            params.duration = duration
            state.params[index] = params


            let discount = state.discounts.filter((item) => {
                return item.duration <= duration
            }).map((item) => {
                return item.discount
            })

            discount.push(0)
            state.discount[service_id] = Math.max(...discount)

            localStorage.setItem('discounts', JSON.stringify(state.discount))
            localStorage.setItem('sub_params', JSON.stringify(state.params))
        },
        SET_SLOTS(state, {index, service_id, slots}) {
            let params = state.params.filter((param) => {
                return param.service_id === service_id
            })[0]
            params.slots = slots
            state.params[index] = params
            localStorage.setItem('sub_params', JSON.stringify(state.params))
        },
        TOGGLE_MODAL(state, {visibility, id}) {
            state.slotsModal.show = visibility
            if (visibility === true && state.slotsModal.id !== id) {
                state.slotsModal.items = []
            }
            state.slotsModal.id = id
            state.id = id
        },
        SET_MODAL_ID(state, id) {
            state.slotsModal.id = id
        },
        ADD_ITEM_TO_SLOT(state, slot) {
            const service_id = state.slotsModal.id
            let params = state.params.filter((param) => {
                return param.service_id === service_id
            })[0]
            if (params) {
                params.items.push(slot)
                params.slots = Math.max(params.slots, params.items.length)
                const index = state.params.map(param => param.service_id).indexOf(service_id)
                state.params[index] = params
                localStorage.setItem('sub_params', JSON.stringify(state.params))
            }
        },
        REMOVE_ITEM_TO_SLOT(state, slot) {
            const service_index = state.services.map(service => service.id).indexOf(state.slotsModal.id)
            if (service_index !== -1) {
                let items = state.params[service_index].items
                let item_index = items.map(item => item.id).indexOf(slot.id)
                items.splice(item_index, 1)
                state.params[service_index].items = items
                localStorage.setItem('sub_params', JSON.stringify(state.params))
            }
        },

        SET_CURRENT(state, current) {
            state.current = current
        },

        CLEAR_SETTINGS(state) {
            state.settings = {
                plus_period: 0,
                plus_slots: 0,
                discount: 0,
                slot_items: []
            }
        }
    }
    ,
    getters: {
        getState: (state) => () => {
            return state
        },
        getItemSlotsList:
            (state) => (id) => {
                const index = state.params.map(param => param.service_id).indexOf(id)
                return state.params[index]
            },
        getServices:
            (state) => () => {
                return state.services
            },
        getStep:
            (state) => () => {
                return state.step
            },
        serviceIndex:
            (state) => (id) => {
                return state.services.map(service => service.id).indexOf(id)
            },
        paramsIndex:
            (state) => (id) => {
                return state.params.map(param => param.service_id).indexOf(id)
            },
        isChecked:
            (state) => (id) => {
                return state.services.map(service => service.id).indexOf(id) > -1
            },
        getDuration:
            (state) => (id) => {
                const index = state.params.map(param => param.service_id).indexOf(id)
                if (index >= 0) {
                    return state.params[index].duration > 1 ? state.params[index].duration : 1
                }
                return 1
            },
        getSlots:
            (state) => (id) => {
                if (id === 0) {
                    id = state.slotsModal.id
                }
                const index = state.params.map(param => param.service_id).indexOf(id)
                if (index >= 0) {
                    const min_slots = Math.max(1, state.params[index].items.length)
                    return state.params[index].slots > min_slots ? state.params[index].slots : min_slots
                }
                return 1
            },
        getBusySlots:
            (state) => (id) => {
                if (id === 0) {
                    id = state.slotsModal.id
                }
                const index = state.params.map(param => param.service_id).indexOf(id)
                if (index >= 0) {
                    return state.params[index].items.length;
                }
                return 0
            },
        isItemPresented:
            (state) => ({service_id, item_id}) => {
                const index = state.params.map(param => param.service_id).indexOf(service_id)
                if (index >= 0) {
                    return state.params[index].items.map(item => item.id).indexOf(item_id) > -1
                }
                return false
            },
        getItems:
            (state) => (id) => {
                const index = state.params.map(param => param.service_id).indexOf(id)
                if (index >= 0) {
                    return state.params[index].items ? state.params[index].items : []
                }
                return []
            },
        getCurrentServiceId:
            (state) => {
                return state.slotsModal.id
            },
        isModalVisible:
            (state) => {
                return state.slotsModal.show
            },
        getItemSlots:
            (state) => {
                const service_index = state.params.map(param => param.service_id).indexOf(
                    state.slotsModal.id
                )
                return service_index !== -1 ? state.params[service_index].items : []
            },
        isSlotPresented:
            (state) => (slot) => {
                const index = state.params.map(param => param.service_id).indexOf(
                    state.slotsModal.id
                )
                if (index >= 0) {
                    return state.params[index].items.map(item => item.id).indexOf(slot.id) > -1
                }
                return false
            },
        getDiscount:
            (state) => (id) => {
                return state.discount[id] || 0
            },
        getUserServicesList:
            (state) => () => {
                return state.current_user_services
            },


        getSettingsPeriod:
            (state) => () => {
                return state.settings.plus_period
            },
        getSettingsSlots:
            (state) => () => {
                return Math.max(state.settings.plus_slots, state.settings.slot_items.length)
            },
        getSettingsItems:
            (state) => () => {
                return [...new Map(state.settings.slot_items.map(item => [item['entity_id'], item])).values()]
            },
        getSettingsItemsLength:
            (state) => () => {
                return state.settings.slot_items.length
            },
        getSettingsDiscount:
            (state) => () => {
                return state.settings.discount
            },
        getSettingsItemSlots:
            (state) => () => {
                return state.settings.slot_items.filter((value, index, array) => array.indexOf(value) === index);
            },
        isInSettingsSlots:
            (state) => (id) => {
                return state.settings.slot_items.map(item => item.entity_id).indexOf(id) !== -1
            }

    }
    ,
    actions: {
        setStep({commit}, step) {
            commit('SET_STEP', step)
        }
        ,
        setDiscounts({commit}, discounts) {
            commit('SET_DISCOUNTS', discounts)
        }
        ,
        toggleService({getters, commit}, service) {
            if (getters.isChecked(service.id)) {
                commit('REMOVE_SERVICE', getters.serviceIndex(service.id))
                commit('CLEAR_PARAMS', getters.paramsIndex(service.id))
            } else {
                commit('ADD_SERVICE', service)
            }
        }
        ,
        hideModal({commit}) {
            commit('TOGGLE_MODAL', {visibility: false, id: 0})
        }
        ,
        showModal({commit}, id) {
            commit('TOGGLE_MODAL', {visibility: true, id: id})

        }
        ,
        setDuration({getters, commit}, {service_id, period}) {
            commit('SET_DURATION', {index: getters.paramsIndex(service_id), service_id: service_id, duration: period})
        }
        ,
        setSlots({getters, commit}, {service_id, slots}) {
            commit('SET_SLOTS', {index: getters.paramsIndex(service_id), service_id: service_id, slots: slots})
        }
        ,
        toggleItemSlot({getters, commit}, {slot, service_id = 0}) {
            if (service_id) {
                commit('SET_MODAL_ID', service_id)
            }
            if (!getters.isSlotPresented(slot)) {
                commit('ADD_ITEM_TO_SLOT', slot)
            } else {
                commit('REMOVE_ITEM_TO_SLOT', slot)
            }
        }
        ,


        setSettingsPeriod({commit}, period) {
            commit('SETTINGS_SET_PERIOD', period)
        }
        ,
        setSettingsSlots({commit}, slots) {
            commit('SETTINGS_SET_SLOTS', slots)
        }
        ,
        setSettingsItems({commit}, items) {
            commit('SETTINGS_SET_ITEMS', items)
        }
        ,
        toggleSettingsItemSlot({commit}, org) {
            commit('SETTINGS_TOGGLE_SLOT', org)
        }
        ,

        setCurrent({commit}, current) {
            commit('SET_CURRENT', current)
        }
        ,

        addToSettingsSlots({commit}, slots) {
            commit('ADD_TO_SETTINGS', slots)
        },

        clearSettings({commit}) {
            commit('CLEAR_SETTINGS')
        }
    }
}
;
